import { SerieDependency } from '../@models/serieDependencie.model'

export class Opening extends SerieDependency {
  constructor(id: number, name: string) {
    super(id, name)
  }
}
